import ServiceLocator from "../../../global/service-locator";
import CourseStats from "./courses-stats";
// import {AnalyticsService} from "../../../services/analytics-service";

export default class IntroductionSection {
    constructor() {
        this.$spinner = document.querySelector('.hero_spinner');
        this.$courseStats = document.querySelector('.course-stats');
        // this.$heroCourseStatsSpacer = document.querySelector('.hero_course-stats-spacer');
        this.$introduction = document.querySelector('.introduction');
        // this.$introductionSidebar = document.querySelector('.introduction-sidebar');
        // this.$priceWidget = document.querySelector('.introduction-sidebar-widget.-price');
        // this.$quizWidget = document.querySelector('.introduction-sidebar-widget.-quiz');
        // this.$courseStatsContainer = document.querySelector('.container.-course-stats');
        // this.$introductionContainer = document.querySelector('.section.-introduction .container');

        this.sl = ServiceLocator.instance;

        this.init();
    }

    init() {
        new CourseStats({
            onDataLoaded: () => {
                this.showContent();
            }
        });
    }

    // setContentWithoutPrice() {
    //     this.$introductionSidebar.classList.add('-without-price');
    //
    //     if (this.$priceWidget) {
    //         this.$priceWidget.remove();
    //     }
    //
    //     if (!this.$quizWidget) {
    //         this.$introduction.classList.add('-faq-only');
    //         this.$courseStatsContainer.classList.add('-tight');
    //         this.$introductionContainer.classList.add('-tight');
    //         this.$heroCourseStatsSpacer.remove();
    //     }
    //
    //     this.showContent();
    // }

    showContent() {
        this.$spinner.remove();
        this.$courseStats.removeAttribute('style');
        this.$introduction.removeAttribute('style');

        const analyticsData = {};
        const lmsUserId = this.sl.userDataService.getLMSUserId();

        if (lmsUserId) {
            analyticsData.lms_id = lmsUserId;
        }
    }
}